import { render } from "./SlugField.vue?vue&type=template&id=06b7eeca"
import script from "./SlugField.vue?vue&type=script&lang=js"
export * from "./SlugField.vue?vue&type=script&lang=js"

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"SlugField.vue"]])

export default __exports__